// @ts-check
// =============================================================================
// js/app/genders.js — the canonical gender-variant list.
//
// Card art variants are keyed by these names (old client GENDERS :75). The
// "_x_" form is how ART objects key their variants; the settings toggles use
// the "_"-joined form (male_x_male art <-> settings.gender.male_male) — see
// settings.js. Order matters: it's also the art-pick priority order.
// =============================================================================

export const GENDERS = [
	'generic',
	'male',
	'female',
	'futa',
	'gyno',
	'male_x_male',
	'male_x_female',
	'male_x_futa',
	'male_x_gyno',
	'female_x_male',
	'female_x_female',
	'female_x_futa',
	'female_x_gyno',
	'futa_x_male',
	'futa_x_female',
	'futa_x_futa',
	'futa_x_gyno',
	'gyno_x_male',
	'gyno_x_female',
	'gyno_x_futa',
	'gyno_x_gyno',
];
